module.exports = __webpack_public_path__ + "img/eko-logo.8b612d83.svg";